module.exports = __webpack_public_path__ + "img/capturas.434dcf5d.svg";